
import * as _asset0 from "inline-asset:assets/galleries/featured/building_343ae7720a__14.jpg";
import * as _asset1 from "asset:assets/galleries/featured/building_343ae7720a__273.jpg";
import * as _asset2 from "asset:assets/galleries/featured/building_343ae7720a__545.jpg";
import * as _asset3 from "asset:assets/galleries/featured/building_343ae7720a__1091.jpg";


export default {
  id: "building",
  aspect: 0.6816836566918777,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 14,
            },{
              url: _asset1.url,
              width: 273,
            },{
              url: _asset2.url,
              width: 545,
            },{
              url: _asset3.url,
              width: 1091,
            }],
};
        